/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';

const iconImageStyles = css({
	flex: '0 0 auto',
	borderRadius: token('border.radius', '3px'),
});

type Props = {
	src: string;
	alt?: string;
	size?: string;
};

const Icon = ({ src, alt = '', size = '16px' }: Props) => (
	<img src={src} alt={alt} css={iconImageStyles} style={{ width: size, height: size }} />
);

export default Icon;
